import { Button } from '@/components/ui/Button'
import type { Template } from '@/types'
import type { TemplateDraftEnvelope } from '@/lib/templateDraft'

type Props = {
  server: Template
  envelope: TemplateDraftEnvelope
  onUseDraft: () => void
  onUseServer: () => void
  onBackToTemplates: () => void
}

function formatWhen(ms: number): string {
  try {
    return new Date(ms).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    })
  } catch {
    return ''
  }
}

export function TemplateDraftConflictDialog({
  server,
  envelope,
  onUseDraft,
  onUseServer,
  onBackToTemplates,
}: Props) {
  const serverUpdated = server.updatedAt
    ? new Date(server.updatedAt).toLocaleString(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short',
      })
    : 'unknown'

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-bg/80 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="draft-conflict-title"
    >
      <div className="w-full max-w-md rounded-lg border border-border bg-surface p-6 shadow-lg">
        <h2 id="draft-conflict-title" className="text-sm font-bold tracking-wide text-ink">
          Local draft is newer than the server copy
        </h2>
        <p className="mt-3 text-xs leading-relaxed text-muted">
          This browser has unsaved work for{' '}
          <span className="font-mono text-ink">{server.name || server.code || 'this template'}</span>{' '}
          (saved locally {formatWhen(envelope.savedAt)}). The last server update was {serverUpdated}.
          Choose how to open the designer.
        </p>
        <div className="mt-6 flex flex-col gap-2">
          <Button className="w-full justify-center" size="lg" onClick={onUseDraft}>
            Continue with local draft
          </Button>
          <Button variant="ghost" className="w-full justify-center" size="lg" onClick={onUseServer}>
            Use server version (discard local draft)
          </Button>
          <Button variant="subtle" className="w-full justify-center" onClick={onBackToTemplates}>
            Back to templates
          </Button>
        </div>
      </div>
    </div>
  )
}
